import { useState, useEffect } from 'react';
import { useApi, identityApiRef } from '@backstage/core-plugin-api';
import { isHomesteadDeveloper } from '../../homesteadDevelopers';

export { HOMESTEAD_DEVELOPER_USER_REFS as AUTHORIZED_USERS } from '../../homesteadDevelopers';

export const useDevToolsAuthorization = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [userRef, setUserRef] = useState<string | null>(null);
  const identityApi = useApi(identityApiRef);

  useEffect(() => {
    const checkAuthorization = async () => {
      try {
        const identity = await identityApi.getBackstageIdentity();
        const currentUserRef = identity.userEntityRef;
        setUserRef(currentUserRef);

        const authorized = isHomesteadDeveloper(currentUserRef);
        setIsAuthorized(authorized);
      } catch {
        setIsAuthorized(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthorization();
  }, [identityApi]);

  return { isLoading, isAuthorized, userRef };
};
